import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';

import { fetchAuthenticated } from 'services/fetch';
import { emitEvent } from 'utils/events';
import { logAction } from 'utils/logs';

import EquipmentModelForm from 'components/forms/EquipmentModelForm';
import ModalRemove from 'components/modals/ModalRemove';
import { buildLogString } from "utils/helpers";

const useStyles = makeStyles({
  overlay: {
    position: "absolute",
    height: "100%",
    mouseEvents: "none"
  }
});

export default function EditEquipmentModels(props) {
  const classes = useStyles();
  const { match, history, setBreadcrumbs } = props;
  const [equipmentModels, setEquipmentModels] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [loadingDialog, setLoadingDialog] = useState(false);

  // Use base equipmentModels url
  console.log(match);
  const equipmentModelsURL = `equipment-model/${match.params.id}`;

  // Set breadcrumbs
  useEffect(() => {
    setBreadcrumbs([
      { path: '/cadastros/modelos', label: 'Modelos' },
      { path: '', label: `${equipmentModels && equipmentModels.name || ''}` }
    ]);
    return () => { setBreadcrumbs([]); }
  }, [setBreadcrumbs, match.params.id, equipmentModels]);

  // Load equipmentModels info
  useEffect(() => {
    const fn = async () => {
      emitEvent('showGlobalLinearProgress');
      const response = await fetchAuthenticated('get', equipmentModelsURL);

      // Any error will redirect to equipmentModelss list
      if (response.status >= 400) {
        emitEvent('showSnack', { message: 'Não foi possível realizar esta ação', type: 'error' });
        history.push('/cadastros/empresas');
      } else {
        const data = await response.json();

        // Update protocol version to expected format

        setEquipmentModels(data);
        logAction(`Acesso ao cadastro do modelo ${data.name}`)
        emitEvent('hideGlobalLinearProgress');
      }
    }; fn();
  }, [history, equipmentModelsURL]);

  // Handle form submission
  const handleSubmit = async (data) => {
    const response = await fetchAuthenticated('put', equipmentModelsURL, data);

    if (!response.ok) {
      throw new Error('')
    } else {
      const data = await response.json();
      setEquipmentModels(data);

      const translateKeys = {
        'name': 'Nome'
      }

      const updatedItemsStr = buildLogString(equipmentModels, data, translateKeys, [])

      logAction(`Edição do modelo ${data.name}${updatedItemsStr}`);
      emitEvent('showSnack', { message: 'Modelo atualizado com sucesso', type: 'success' });
    }
  }

  // Handle cancel button click
  const handleCancel = () => {
    history.push('/cadastros/modelos');
  }

  // Handle remove button click
  const handleRemove = () => {
    console.log('Handle remove');
    setShowDialog(true);
  }

  // Update show dialog variable to close modal
  const handleDialogClose = () => {
    setShowDialog(false);
  }

  // Handle remove confirmation
  const handleRemoveConfirm = async () => {
    setLoadingDialog(true);
    let redirect = false;
    try {
      const response = await fetchAuthenticated('delete', equipmentModelsURL);

      if (response.status >= 400) {
        emitEvent('showSnack', { message: 'Não foi possível remover o modelo', type: 'error' });
      } else {
        logAction(`Remoção do modelo ${equipmentModels.name}`);
        emitEvent('showSnack', { message: 'Modelo removido com sucesso', type: 'success' });
        redirect = true;
      }
    } catch (err) {
      console.log('Error', err);
    } finally {
      setLoadingDialog(false);
      setShowDialog(false);

      // Redirects to user list if everything was ok
      if (redirect) {
        history.push('/cadastros/modelos');
      }
    }
  }

  return (
    <div>
      <EquipmentModelForm
        title='Detalhes do Modelo'
        data={equipmentModels}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        handleRemove={handleRemove}
      />

      <ModalRemove
        isVisible={showDialog}
        setIsVisible={setShowDialog}
        titleLabel='do modelo'
        onSubmit={handleRemoveConfirm}
        isLoading={loadingDialog}
        removeLabel='o modelo'
        extraContent='Ao realizar está ação o modelo não estará mais disponível'
      />

    </div>
  );
}
